import { Grid, DiceValue, Difficulty } from '../types';
import { getAvailableColumns } from './score';

export const getBestMove = (
  opponentGrid: Grid,
  playerGrid: Grid,
  currentDie: DiceValue,
  difficulty: Difficulty
): number => {
  const available = getAvailableColumns(opponentGrid);
  
  if (available.length === 0) return 0;

  // EASY: Pure random
  if (difficulty === 'EASY') {
    return available[Math.floor(Math.random() * available.length)];
  }

  // Strategy for MEDIUM and HARD
  let bestDestructionScore = -1;
  let destructionCol = -1;

  available.forEach(colIdx => {
    const playerCol = playerGrid[colIdx];
    const matchingCount = playerCol.filter(v => v === currentDie).length;
    if (matchingCount > 0) {
      const destructionVal = matchingCount * currentDie;
      if (destructionVal > bestDestructionScore) {
        bestDestructionScore = destructionVal;
        destructionCol = colIdx;
      }
    }
  });

  // HARD: Always prioritize maximum destruction
  if (difficulty === 'HARD' && destructionCol !== -1) {
    return destructionCol;
  }

  // MEDIUM: 70% chance to play strategically
  if (difficulty === 'MEDIUM' && Math.random() < 0.3) {
    return available[Math.floor(Math.random() * available.length)];
  }

  if (destructionCol !== -1) return destructionCol;

  // Try to match own dice for multiplier
  for (const colIdx of available) {
    if (opponentGrid[colIdx].includes(currentDie)) {
      return colIdx;
    }
  }

  return available[Math.floor(Math.random() * available.length)];
};
